"use client";

import { CandleSetupGroup, DataItem } from "@/types";
import { CandlePatternInfo } from "@/lib/candlePatternInfo";
import SignalWorkspace from "./SignalWorkspace";

interface DojiTabProps {
  items: DataItem[];
  uniqueTypes: string[];
  setupGroups?: CandleSetupGroup[];
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
  selectedPatternInfo: CandlePatternInfo | null;
  trendFilter: "all" | "up" | "down";
  setTrendFilter: (filter: "all" | "up" | "down") => void;
  timeframe?: "daily" | "weekly" | "monthly";
}

export default function DojiTab(props: DojiTabProps) {
  return (
    <SignalWorkspace
      {...props}
      mode="patterns"
      tableVariant="doji"
      title="Doji Scanner"
      description="Focus only on doji families, including the bearish-exhaustion doji reversal setup, without scanning the full pattern list."
      emptyMessage="Select a doji family to review the live matches and the surrounding candle context."
    />
  );
}
